import React from 'react';

interface SectionLayoutProps {
  title: string;
  children?: React.ReactNode;
}

export function SectionLayout({ title, children }: SectionLayoutProps) {
  return (
    <div className="p-6">
      <h1 className="h1 mb-6">{title}</h1>
      <div className="section-content">
        {children}
      </div>
    </div>
  );
} 